export const screenSizes = {
    sm: 320,
    md: 480,
    lg: 869,
    xl: 1100,
    "2xl": 1400,
    "3xl": 1920,
};
export const screens = Object.fromEntries(Object.entries(screenSizes).map(([key, value]) => [key, `${value}px`]));
//# sourceMappingURL=screens.js.map